import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './contact-info.routes';
import api from '../../../components/api-service';
import util from '../../../components/util/util.module';
import emailService from '../../../components/email-service';

import 'angular-translate';
import feconClientBundle from '@infocert/fecon-client-bundle';
const translateModule = 'pascalprecht.translate';

import vcRecaptcha from 'angular-recaptcha';

export class ContactInfoController {

    constructor(notifier, $state, $log, LmrcApiService, queryParamGetter) {
        'ngInject';
        this._logger = $log.getInstance('ContactInfoController');
        this.notifier = notifier;
        this._$state = $state;
        this._lmrcApiService = LmrcApiService;
        this._queryParamGetter = queryParamGetter;
        this.initLoading = false;
        this.loading = false;
    }

    $onInit() {
        this._logger.debug("$onInit");
        this.initLoading = true;
        this._lmrcApiService.getContactInfo().then(resp => {
            this.initLoading = false;
            this._logger.debug("getContactInfo response", resp);
            this.initData = resp.data;
            this.inputEmail = resp.data.alternativeEmail;
            this.inputSms = resp.data.mobilePhone;
        }, err => {
            this._logger.debug("getContactInfo failed", err);
            this.errorMessage = 'Si &egrave; verificato un errore.';
        });
    }

    updateContactInfo(formValid) {
        if (formValid) {
            this.loading = true;
            this._logger.debug("inputEmail", this.inputEmail);
            this._logger.debug("inputSms", this.inputSms);
            let request = {
                'alternativeEmail': this.inputEmail,
                'mobilePhone': this.inputSms
            };

            const defaultGoToPhase = 'external.success';
            var onCompletionGoTo = Promise.resolve(defaultGoToPhase);
            const customizationId = _.trim(this._queryParamGetter('ui', true));
            if (customizationId) {
                onCompletionGoTo = this._lmrcApiService.getCustomization(customizationId)
                    .then(resp => {
                        this._logger.debug("getCustomization response", resp.data);
                        this._logger.debug("getCustomization doChangePasswordPhase?", resp.data.doChangePasswordPhase);
                        if (resp.data.doChangePasswordPhase) {
                            return 'external.change-password'
                        } else {
                            return defaultGoToPhase;
                        }
                    }, err => {
                        this._logger.debug("getCustomization failed, using default conf", err);
                        return defaultGoToPhase;
                    });
            } else {
                logger.debug("getCustomization no customization")
            }

            if (this.initData.alternativeEmail === request.alternativeEmail &&
                this.initData.mobilePhone === request.mobilePhone) {
                this._logger.debug("contact info not modified skip request to BE");
                onCompletionGoTo.then(goToPhase => {
                    this._logger.debug("custom goto resolved: go to " + goToPhase);
                    this._$state.go(goToPhase);
                }, err => {
                    this._logger.debug("error getting custom goto, default go to " + defaultGoToPhase);
                    this._logger.debug("error was ", err)
                    this._$state.go(defaultGoToPhase);
                });
                return;
            }

            this._lmrcApiService.updateContactInfo(request).then(() => {
                this.loading = false;
                onCompletionGoTo.then(goToPhase => {
                    this._logger.debug("go to " + goToPhase);
                    this._$state.go(goToPhase);
                }, err => {
                    this._logger.debug("go to " + defaultGoToPhase);
                    this._$state.go(defaultGoToPhase);
                });
            }, (err) => {
                this.loading = false;
                this._logger.debug("updateContactInfo failed", err);
                this.errorMessage = 'Si &egrave; verificato un errore. Si prega di riprovare';
            });
        }
    }


}

export default angular.module('lmrcApp.contact-info', [
        uiRouter,

        translateModule,

        feconClientBundle,
        vcRecaptcha,
        util,
        api,
        emailService
    ])
    .config(routing)
    .component('contactInfo', {
        template: require('./contact-info.html'),
        controller: ContactInfoController
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/features/contact-info/index.js